export default __webpack_public_path__ + "static/media/partner3.fb14fa60.webp";